export default __webpack_public_path__ + "static/media/chintan.b85917a8.jpeg";